const initialstate = {
  fetching: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
};

const getTestConversationResponseReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'FETCHING_TEST_CONVERSATION_RESPONSE':
      return Object.assign({}, state, {
        fetching: true,
        fetchingSuccessful: null,
        fetchingFailed: null,
      });
    case 'FETCHING_TEST_CONVERSATION_RESPONSE_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
      });
    case 'FETCHING_TEST_CONVERSATION_RESPONSE_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: false,
        fetchingFailed: true,
        error: true,
        errorText: action.payload,
      });
    default:
      return state;
  }
};

export default getTestConversationResponseReducer;
